export default __webpack_public_path__ + "cd4542e13219af50f23ff6520f5bd2e8.jpg";